module.exports = __webpack_public_path__ + "img/know-6.c54db025.jpg";